import React, {Fragment } from 'react';
import { 
    useQuery, 
    Loading, 
    Error,
    TextInput,
    DateInput,
    ArrayInput,
    SimpleFormIterator,
    
 } from 'react-admin';

import HtmlToReact from 'html-to-react'


var HtmlToReactParser = HtmlToReact.Parser;
var htmlToReactParser = new HtmlToReactParser();


const Heading=({data})=>{
    return (<h3>{data}</h3>)
}

  const classes = {
    root: { alignItems: 'flex-start'},
    trainer_init: {  width: '2em' },
    trainee_init: {  width: '2em' },
    booth: {  width: '2em' },
    date: {  
        width: '1em',
        display: 'inline',
        margin: '2px',
        padding: '2px',
    },
    date_prof: {  width: '7em' },

    inlineBlock: {
        display: 'inline',
        margin: '2px',
        padding: '2px',
    },
    cell30per :{
        width:"30%", 
        cellSpacing:"10",
    },
    hidden : {
        display: 'none',
        visibility: 'hidden',
    }
};

const Contents =({data, field})=>{
    // console.log(data)
     var contents  = [];
     let i=0
     if(data){
       try{
         contents =JSON.parse(data) 
       } catch(e) {
         //console.log(e)
         contents = data;
       };
     }
     //console.log(contents)
    // console.log(field)
     
     return(
       <>
       {
        contents && contents.map((item, index) =>(
         <tr  key={index}>
             <td style={{fontWeight:'bold'}}>{htmlToReactParser.parse(item['procedure'])} <TextInput source={`${field}_proc_${++i}`} defaultValue={item['procedure']}  style={{ display: 'none', visibility: 'hidden'}} /></td>
             <td>{htmlToReactParser.parse(item['referance'])}<TextInput source={`${field}_referance_${i}`} defaultValue={item['referance']}   style={{ display: 'none', visibility: 'hidden'}} /></td>
             <td><DateInput source={`${field}_introduced_date_${i}`}    label="" locales="en-us"  /></td>
             <td><TextInput source={`${field}_trainer_init_${i}`} label="" /></td>
             <td><TextInput source={`${field}_trainee_init_${i}`} label="" /></td>
             <td><DateInput source={`${field}_proficient_date_${i}`}    label="" locales="en-us"  /></td>
        </tr>
        )
        
       )}
       <tr>
            <td colSpan="6"><TextInput source={`${field}_count`} defaultValue={i} label='' style={{ display: 'none', visibility: 'hidden'}} /></td>
        </tr>
      </>
     )
 }


 const getTable=(_rows, _fields)=>{
    var nums = []
    for(var i=0; i < _rows; i++){nums.push(i)}

    return (
    <>
    {
       nums.map((nitem, i)=>(
        <tr key={i}>
            {
            _fields && _fields.map((item, index)=>(
                <td>
                    <TextInput source={item + i + '_'+ index} fullWidth label="" />
                </td>
                    )
            )
            }
        </tr>
       )
    )}
    </>
    )
}

const Forms =({data})=>{
    var forms = [];
    if(data){
        try{
            forms = JSON.parse(data);
        } catch(e){
            forms = data;
        }
    }
   
    var tot_size = 0;
    forms && forms.map((fitem)=>(
        fitem['form_fields'].map((item)=>(tot_size+= item['field_size'])
            )
        ) 
    )

    var factor = 100/ tot_size
    
    return(
        <>
        {
            forms && forms.map((fitem, findex)=>(
                <>
                <p></p>
                <p style={{textAlign:'center', fontWeight:'bold'}}>{fitem['form_subheading']}</p>
                <table border="1" cellSpacing="0" style={{width: "100%", textAlign:"center"}}>
                <tbody>
                    <tr key={findex+50}>
                    {
                    fitem['form_fields'].map((item, index) =>(
                        <td style={{width: `${factor * (item['field_size']?item['field_size']: 50 )}%`}}><b>{htmlToReactParser.parse(item['field_name'])}</b></td>
                        )
                    )}
                    </tr>  
                    {getTable(fitem['num_rows'], fitem['form_fields'])}
                </tbody>    
                </table>
                <p></p>
                <p></p>
                 </>
            )

        )}
        </>
    )
}


const ContentCreate = (props) =>{
    
    let uid = (props && props.uid)? props.uid :  null;

    const { data, loading, error } = useQuery({ 
        type: 'getOne',
        resource: 'userslist',
        payload:  {id: uid}
    });

    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;
    //console.log(data)
    return (
        <Fragment>
        <table style={{width:"99%", fontSize: "12px"}}>
            <tbody>
            <tr>
                <td colSpan="4">
                    <table  border ="1" cellSpacing="0" style={{width:"100%", textAlign: "center"}}>
                    <tbody>
                    <tr>
                        <td>
                            <table  border ="0" style={{width:"100%", textAlign: "center"}}>
                            <tbody>
                            <tr>
                                <td style={{fontSize: "9px"}}> 
                                    Training and Education Procedures
                                </td>
                            </tr>
                            <tr>
                                <td ><Heading  data={data && data.name} /><TextInput source='name' defaultValue={data && data.name}   style={{ display: 'none', visibility: 'hidden'}} /></td>
                            </tr>
                           
                            </tbody>
                            </table>
                        </td>                  
                    </tr>
                    </tbody>
                    </table>
                </td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            <tr>
                <td>Trainee Name:</td>
                <td classes={classes.cell30per}><TextInput source="trainee" label="" defaultValue={data && data.full_name}/></td>
                <td>&nbsp;Center:</td><td classes={classes.cell30per}><TextInput source="location"   label="" defaultValue={data && data.location} /></td>
            </tr>
            <tr>
                <td>Trainer Name:</td><td classes={classes.cell30per}><TextInput source="trainer1" label=""/></td>
                <td>&nbsp;Initial:</td><td classes={classes.cell30per}><TextInput source="trainer1_init" label=""/></td>
            </tr>
            <tr>
                <td>Trainer Name:</td><td classes={classes.cell30per}><TextInput source="trainer2" label=""/></td>
                <td>&nbsp;Initial:</td><td classes={classes.cell30per}><TextInput source="trainer2_init" label=""/></td>
            </tr>
            <tr>
                <td>Trainer Name:</td><td classes={classes.cell30per}><TextInput source="trainer3" label=""/></td>
                <td>&nbsp;Initial:</td><td classes={classes.cell30per}><TextInput source="trainer3_init" label=""/></td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            <tr>
                <td colSpan="4">
                    <table border="1" cellSpacing="0" style={{ width:"100%"}}>
                        <tbody>
                            <tr>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"25%", textAlign: "center"}}>Procedure</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"35%", textAlign: "center"}}>Reference</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"12%", textAlign: "center"}}>Date Introduce</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"8%", textAlign: "center"}}>Trainer Initial</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"8%", textAlign: "center"}}>Trainee Initial</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"12%", textAlign: "center"}}>Date Proficient</th>
                            </tr>
                            <Contents   data={data && data.content1}  field={'content1'} />
                            <tr>
                                <td colSpan="6" style={{backgroundColor: "silver", fontWeight: "bold", textAlign: "center"}}><Heading  data={data && data.sub_heading} />
                                <TextInput source='sub_heading' defaultValue={data && data.sub_heading}   style={{ display: 'none', visibility: 'hidden'}} /></td>
                            </tr>
                            <Contents   data={data && data.content2} field={'content2'} />
                        </tbody>
                    </table>
            
                </td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            <tr>
                <td>Trainee Signature:</td><td classes={classes.cell30per}><TextInput source="trainee_sign" label=""/></td>
                <td>&nbsp;Date:</td><td classes={classes.cell30per}><DateInput source='trainee_sign_date'    label="" locales="en-us"  /></td>
            </tr>
            <tr>
                <td>Center Manager Signature:</td><td classes={classes.cell30per}><TextInput source="mgr_sign" label=""/></td>
                <td>&nbsp;Date:</td><td classes={classes.cell30per}><DateInput source='mgr_sign_date'    label="" locales="en-us"  /></td>
            </tr>
            <tr>
                <td>Quality Assurance Signature:</td><td classes={classes.cell30per}><TextInput source="qa_sign" label=""/></td>
                <td>&nbsp;Date:</td><td classes={classes.cell30per}><DateInput source='qa_sign_date'    label="" locales="en-us"  /></td>
            </tr>
            <tr>
                <td colSpan="4">
                {
                    (data && data.form_heading) &&
                    <table style={{width: "100%"}}>  
                        <tbody>
                        <tr>
                            <td  colSpan="4">&nbsp;</td></tr>
                        <tr>
                            <td colSpan="4"><hr /></td>
                        </tr>
                        <tr>
                            <td  colSpan="4">&nbsp;</td>
                        </tr>
                            
                        <tr>
                            <td colSpan="4" style={{textAlign:"center"}}><h2 >TRAINING FORM</h2></td>
                        </tr>
                        <tr> 
                            <td colSpan="4" style={{textAlign: "center"}}>
                                <Heading  data={data && data.form_heading} />
                                <TextInput source="form_heading" label="" defaultValue={data && data.form_heading} style={{visibility: "hidden"}} />
                            </td>
                        </tr>
                        <tr>
                            <td >Trainee Name:</td>
                            <td colspan="2" ><TextInput source="trainee" label="" defaultValue={data && data.full_name} fullWidth/></td>
                            <td  style={{cellSpacing:"10", alignSelf:"start" }}>&nbsp;</td>
                        </tr>
                        <tr>
                            <td  colSpan="4">&nbsp;</td>
                        </tr>
                        <tr>
                            <td  colSpan="4">&nbsp;</td>
                        </tr>
                        <tr>
                            <td colSpan="4">
                            <Forms data={data && data.forms} />
                            </td>
                        </tr>
                        <tr><td  colSpan="4">&nbsp;</td></tr>
                        <tr>
                            <td>Trainee Signature:</td><td style={{width:"30%",cellSpacing:"10" }}><TextInput source="form_trainee_sign" label=""/></td>
                            <td>&nbsp;Date:</td><td style={{width:"30%",cellSpacing:"10" }}><DateInput source='form_trainee_sign_date'    label="" locales="en-us"  /></td>
                        </tr>
                        <tr>
                            <td>Quality  Signature:</td><td style={{width:"30%", cellSpacing:"10" }}><TextInput source="form_qa_sign" label=""/></td>
                            <td>&nbsp;Date:</td><td style={{width:"30%", cellSpacing:"10" }}><DateInput source='form_qa_sign_date'    label="" locales="en-us" /></td>
                        </tr>
                        <tr><td  colSpan="4">&nbsp;</td></tr>
                        <tr>
                            <td colSpan="3" style={{fontSize: "7"}}>{data && data.form_footer}</td>
                            <td>&nbsp;</td>
                        </tr>
                        </tbody>
                   
                    </table>
                }
                </td>
            </tr>
            </tbody>
        </table>
        </Fragment>
        )
}

export default ContentCreate
